<script>
import UserResource from '@/resources/user'

export default {
    props: {
        pollSeconds: String
    },
    components: {},
    computed: {
        reservations() {
            if (!this.pageData) {
                return []
            }

            return this.pageData.resources
        },
        reservationsUpcoming() {
            const now = new Date()
            const sixHoursFromNow = new Date(now.getTime() + 6 * 60 * 60 * 1000)
            return this.reservations.filter((reservation) => {
                const date = new Date(reservation.attributes.time)
                return date >= now && date <= sixHoursFromNow
            })
        },
        reservationText() {
            if (this.reservationsUpcoming.length > 0) {
                const uniqueCalendars = [...new Set(this.reservationsUpcoming.map((item) => item.attributes.calendar))]

                if (uniqueCalendars.length == 1) {
                    return this.reservationsUpcoming[0].attributes.calendar_name
                } else {
                    return `${uniqueCalendars.length} Sims`
                }
            }

            return null
        },
        calendarId() {
            if (this.reservationsUpcoming.length > 0) {
                return this.reservationsUpcoming[0].attributes.calendar
            }

            return null
        }
    },
    watch: {},
    data() {
        return {
            loading: true,
            pageData: null,
            pollTimeoutID: null
        }
    },
    methods: {
        async load() {
            this.pageData = await UserResource.getReservationsFuture()
            this.loading = false

            this.$emit('reservations', {
                future: this.reservations,
                upcoming: this.reservationsUpcoming
            })

            if (this.pollSeconds) {
                this.pollTimeoutID = setTimeout(() => this.load(), this.pollSeconds * 1e3)
            }
        }
    },
    async beforeMount() {
        await this.load()
    },
    beforeDestroy() {
        if (this.pollTimeoutID) {
            clearInterval(this.pollTimeoutID)
        }
    }
}
</script>

<template>
    <b-alert v-if="reservationsUpcoming.length > 0" variant="info" show>
        <b-row>
            <b-col>
                Vous avez une course à venir le <strong>{{ reservationText }}</strong>. <b-link :to="{ name: 'calendarControlWaitingRoom', params: { calendarId } }"><b-icon icon="controller" /> Aller au contrôleur Sim</b-link>
            </b-col>
        </b-row>
    </b-alert>
</template>

<style lang="scss" scoped>
</style>
